import { getUserTimeZone } from "../utilities/timeZone";
import { getUserLocaleCode } from "../utilities/userLocaleConfig";
import { clientCodeHeader } from "./clientApiContext";

interface Params {
  formData?: boolean;
}

export const getDefaultHeaders = (params?: Params) => {
  const headers: Record<string, string> = {
    ...clientCodeHeader(),
    "X-Entrilia-Locale-Code": getUserLocaleCode(),
    "X-Entrilia-Time-Zone": getUserTimeZone(),
  };

  if (params?.formData) {
    headers["Content-Type"] = "multipart/form-data";
  }

  return headers;
};
